module.exports = __webpack_public_path__ + "static/2-414e3bcb97b6c04a8a827778a005b598.jpg";